export const SHOP_DETAILS_ERROR_TITLE =
  "Uh oh! We were unable to load the hotel details.";
